/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { FormTypes } from '@powdr/constants';

export const FirstTimersGuideV2Form = ({
  reCaptchaPublicKey,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText,
}) => {
  const captchaRef = useRef();

  return (
    <form
      id="first-timers-guide-v2"
      onSubmit={(e) => processForm(
        e,
        null,
        null,
        captchaRef,
        FormTypes.SILVERPOP,
      )}
    >
      <input name="CONTACT_LIST_ID" type="hidden" value="16824205" />

      {/* <!-- DO NOT REMOVE HIDDEN FIELD sp_exp --> */}
      <input type="hidden" name="formSourceName" value="StandardForm" />
      <input type="hidden" name="sp_exp" value="yes" />

      <p>Sign up for our emails to stay in the know on all things Woodward!</p>
      <h2>Get exclusive updates and promotions</h2>

      <input
        name="First Name"
        id="control_COLUMN3"
        className="form-control"
        type="text"
        placeholder="First Name *"
        required
      />

      <input
        name="Last Name"
        id="control_COLUMN4"
        className="form-control"
        type="text"
        required
        placeholder="Last Name *"
      />

      <input
        name="Email"
        id="control_EMAIL"
        className="form-control"
        type="email"
        placeholder="Email *"
        required
      />

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={reCaptchaPublicKey}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />

      <button type="submit" value="Submit" disabled={!isUserVerified}>{buttonText || 'Request Info'}</button>
    </form>
  );
};

FirstTimersGuideV2Form.propTypes = {
  reCaptchaPublicKey: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};
